export default __webpack_public_path__ + "static/media/icon_cross_white.82d519a2.svg";